import React, { useContext } from 'react'
import { Typography } from '@mui/material'
import { PrefillReviewPageApplicationFormContext } from '../../../../../src/components/ApplicationForm/PrefillReviewPageApplicationFormContext'
import { RequiredInfo } from '../../RequiredInfo/RequiredInfo'
import { ApplicationFormContext } from '../../../../../src/components/ApplicationForm/ApplicationFormContext'
import { logContentClicked } from '../../../../../src/utils/PrefillReviewPageApplicationForm-utils'

type DataRowProps = {
  field: string
  value: string | undefined
  testId?: string
  infoId?: string
  lastRow?: boolean
  onClick?: React.MouseEventHandler<HTMLDivElement>
  hideRequired?: boolean
}

const DataRow = ({
  field,
  value,
  testId,
  infoId,
  lastRow,
  onClick,
  hideRequired
}: DataRowProps) => {
  const { experimentName } = useContext(PrefillReviewPageApplicationFormContext)
  const { featureSwitches } = useContext(ApplicationFormContext)
  const {
    reviewPageV3
  } = featureSwitches ?? {}

  let content = null

  // If the passed string includes undefined, render required
  if (value && value.includes('undefined') && !hideRequired) {
    content = <RequiredInfo experimentName={experimentName} testId={`required-${infoId}`} onClickHandler={onClick} clickable={reviewPageV3} />
    // If the passed string doesn't include undefined, render the actual content
  } else if ((value && !value.includes('undefined'))) {
    content = (
      <Typography variant="rowHeading" data-testid={testId} id={testId} onClick={() => logContentClicked(experimentName, infoId)}>
        {value}
      </Typography>
    )
  // Fallback for when value is actually undefined (value isn't provided and it's not a string containing undefined)
  } else if (!hideRequired) {
    content = <RequiredInfo experimentName={experimentName} testId={`required-${infoId}`} onClickHandler={onClick} clickable={reviewPageV3} />
  }

  return (
    <div className="data-row" style={lastRow ? { marginBottom: 0 } : {}}>
      <div className="heading">
        <Typography
          variant="rowHeading"
          data-testid={testId && `${testId}-heading`}
          id={testId && `${testId}-heading`}
        >
          {field}:
        </Typography>
      </div>
      <div className="content" data-hj-suppress="" id={`${infoId}-answer`}>
        {content}
      </div>
    </div>
  )
}

export default DataRow
